import { useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import CardComponent from '@/components/Content/SearchPart/FacilityResult/CardComponent'
import useStore from '@/hooks/useStore'
import './index.less'

function FacilityResult(props: { isFromUrlId: string }) {
  const uiStore = useStore('uiStore')
  const facilityStore = useStore('facilityStore')
  const mapStore = useStore('mapStore')
  const cardRef = useRef<any>(null)

  useEffect(() => {
    console.log('mapStore.viewer', mapStore.viewer)
    if (mapStore.viewer) {
      const url = window.location.href
      const paramsObj: any = {}
      if (url) {
        const params = url.includes('?') && url.split('?')[1]
        if (params) {
          const paramsArr = params.split('&')
          paramsArr.forEach((item) => {
            const key = item.split('=')[0]
            const value = item.split('=')[1]
            paramsObj[key] = value
          })
        }
      }
      if (cardRef && cardRef.current && props.isFromUrlId) {
        setTimeout(() => {
          cardRef.current.itemClick && cardRef.current.itemClick(paramsObj.idlFcltUnqNo)
        }, 3000)
      }
    }
  }, [mapStore.viewer])
  return (
    <>
      <div className={'FacilityResult'} style={{ height: uiStore.uiHeight - 526 }}>
        {facilityStore.SearchResults.map((item, index) => (
          <CardComponent
            {...item}
            key={index}
            tag={item.tag}
            name={item.name}
            addr={item.addr}
            imgSrc={item.imgSrc}
            footerTag={item.footerTag}
            idlFcltUnqNo={item.idlFcltUnqNo}
            isFromUrlId={props.isFromUrlId}
            sggCd={item.sggCd}
            like={item.like}
            posFclt={{ x: item.x, y: item.y }}
            ref={cardRef}
          />
        ))}
      </div>
    </>
  )
}

export default observer(FacilityResult)
